// Load global configuration
require('./globals')

import './assets/scss/_global.scss'

//SCSS overrides
import './assets/scss/overrides/awesome-notifications.scss'
import './assets/scss/overrides/vue-select.scss'
import './assets/scss/overrides/vue-date.scss'
import './assets/scss/overrides/vue-multiselect.scss'
import './assets/scss/overrides/v-tooltip.scss'
import './assets/scss/overrides/vue2-editor.scss'
import './assets/scss/overrides/vue-checkbox-radio.scss'

// vuejs-dialog
import 'vuejs-dialog/dist/vuejs-dialog.min.css'
// vue-tel-input global styles
import 'vue-tel-input/dist/vue-tel-input.css'
import './assets/scss/overrides/tweaks-and-fixes.scss'

import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueRouter from 'vue-router'
import VueMoment from 'vue-moment'
import VTooltip from 'v-tooltip'
import Tabs from 'vue-tabs-component-pluralo'
import Toasted from 'vue-toasted'
import ProgressBar from 'vue-progressbar'
import AsyncComputed from 'vue-async-computed'
import Vuelidate from 'vuelidate'
import ToggleButton from 'vue-js-toggle-button'
import CheckboxRadio from 'vue-checkbox-radio'
import VuejsDialog from "vuejs-dialog"
import Notifications from 'vue-notification'
import pagination from "vuejs-uib-pagination"
import VueAnalytics from 'vue-analytics'
import Clipboard from 'v-clipboard'
import VueAWN from "vue-awesome-notifications"
import { ApplicationInsights } from '@microsoft/applicationinsights-web'

import App from './App.vue'

// Setting up routes, store
import { routes } from './routes/routes'
import store from '@/store/store';

// Import global mixins and auth
import Mixins from './mixins'

// Directives and filters
import { clickOutsideDirective, focusDirective } from './directives/directives'
import { ellipsisFilter } from './filters/filters'

import VueIntercom from 'vue-intercom';
import VueI18n from 'vue-i18n';
import VueTelInput from 'vue-tel-input';
import messages from './i18n/i18n';



// Router
const router = new VueRouter({
    routes,
    mode: 'history',
    saveScrollPosition: true
});

let appInsights = null;

// Application Insights config
if (process.env.NODE_ENV === 'production') {
  appInsights = new ApplicationInsights({
    config: {
      connectionString: process.env.APPLICATION_INSIGHTS_CONNECTION_STRING,
      enableAutoRouteTracking: false,
    }
  });

  appInsights.loadAppInsights();
}

Vue.router = router;

// Fire dependencies
Vue.use(VueRouter)
Vue.use(VueMoment)
Vue.use(Tabs)
Vue.use(VTooltip, {
    defaultBoundariesElement: document.body,
    defaultContainer: 'body',
  })
Vue.use(VueAxios, axios)
Vue.use(Vuelidate)
Vue.use(AsyncComputed)
Vue.use(ProgressBar, {
    color: '#f16c64',
    thickness: '5px',
    latencyThreshold: 200, // Minimum latency to display the bar
    speed: 500,            // Speed of the bar (higher = slower)
    minimum: 0.1,          // Minimum progress (0 to 1) that the bar reaches
})
Vue.use(Toasted, {
    fitToScreen: true,
    fullWidth: false,
    position: 'top-center',
    className: 'alert',
    duration: 7000,
})
Vue.use(Mixins)
Vue.use(ToggleButton)
Vue.use(CheckboxRadio)
Vue.use(VuejsDialog, {
    html: true,
    okText: 'Yes',
    cancelText: 'No',
    animation: 'zoom',
    backdropClose: true,
})
Vue.use(Notifications)
Vue.use(pagination)
Vue.use(VueAnalytics, {
  id: process.env.GOOGLE_ANALYTICS_ID,
  router
})
Vue.use(VueIntercom, { appId: 'zetpu2p7' });
Vue.use(Clipboard)
Vue.use(VueI18n)
Vue.use(VueAWN, {
    position: 'top-right',
    duration: 10000,
})
Vue.use(VueTelInput);

require("vue-awesome-notifications/dist/styles/style.css") //VueAWN

const i18n = new VueI18n({
    locale: 'fr', // set locale
    messages // set locale messages
})

// Directives and filters
Vue.directive('force-focus', focusDirective);
Vue.directive('click-outside', clickOutsideDirective);
Vue.filter('ellipsis', ellipsisFilter);

Vue.directive('numInt', {
    bind(el, binding, vnode) {
        let handler = function(e) {
            var currentVal = e.target.value;
            var editedVal = e.target.value.replace(/[^0-9]/g, '');
            if (editedVal != currentVal) {
                e.target.value = editedVal
                vnode.elm.dispatchEvent(new CustomEvent('input'));
            }
        }
        el.addEventListener('input', handler);
    }
})

Vue.directive('numFloat', {
    bind(el, binding, vnode) {
        let handler = function(e) {
            var currentVal = e.target.value;
            var editedVal = e.target.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')
            if (editedVal != currentVal) {
                e.target.value = editedVal
                vnode.elm.dispatchEvent(new CustomEvent('input'));
            }
        }
        el.addEventListener('input', handler);
    }
})

// Load async/sync requests configuration
require('./transport')

// eventBus that allows us to do $emit between diferent components
export const eventHub = new Vue();

new Vue({
    el: '#app',
    router,
    store,
    data() {
      return {
      }
    },
    mounted() {
        if(process.env.SHOW_INTERCOM == true){
            this.$intercom.boot();
        }
    },
    watch: {
      email(email) {
        this.$intercom.update({email});
      },
    },
    components: {
        App
    },
    render: function(createElement) {
        return createElement(App);
    },
});

export { appInsights, router };



// WEBPACK FOOTER //
// ./src/main.js